import memoize from 'moize';

export const flattenKeyValueItems = memoize.deep(
  ({ keyValueItems = [] }: { keyValueItems?: any }) =>
    Object.values(keyValueItems).reduce(
      (obj: any, item: any) => ({ ...obj, [item?.key]: item?.valueMarkdown?.valueMarkdown }),
      {}
    )
);
